// const state = {}

// ==================================================
// INITIALIZERS
// ==================================================

function setDefaultState() {
    // set default state
}

function setListeners() {
    // set listeners
}

// ==================================================
// HANDLERS
// ==================================================

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    setDefaultState();
    setListeners();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/fiddle.js